const config = {
  apiBaseUrl: "https://urbanneed.co.uk/admin/API/",
  baseUrl: "https://urbanneed.co.uk/admin/",
};

export default config;
